// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import translate from "@insite/client-framework/Translate";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
// import { LinkPresentationProps } from "@insite/mobius/Link"; // Starter Custom Code
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import React, { FC, useState } from "react"; // Starter Custom Code
import { css } from "styled-components";

/* Starter Custom Code - Start */
import EditNotesFormModal from "@store/Library/Components/Toolkit/EditNotesFormModal";
import ArrowiOSDownward from "@store/Library/Components/Toolkit/Icons/ArrowiOSDownward";
import Link, { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, useRef, useState } from "react";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
/* Store Custom Code - End */

interface OwnProps {
    cart: Cart;
    /**
     * If true, the notes will display in a text field for editing.
     * If false, the notes will display as read-only text.
     * Default value: false
     */
    editable?: boolean;
    onNotesChange?: (updatedNotes: string) => void;
    label?: string;
    extendedStyles?: CartLineNotesStyles;
}

type Props = OwnProps & HasCartLineContext;

export interface CartLineNotesStyles {
    wrapper?: InjectableCss;
    /** @deprecated */
    toggleLink?: LinkPresentationProps;
    label?: TypographyPresentationProps;
    editableNotesTextArea?: TextAreaProps;
    readOnlyNotesText?: SmallHeadingAndTextStyles;
    // Starter Custom Code
    linkWrapper?: InjectableCss;
    link?: LinkPresentationProps;
    editNotesLink?: LinkPresentationProps;
    addNotesLink?: LinkPresentationProps;
}

export const cartLineNotesStyles: CartLineNotesStyles = {
    wrapper: productLineProps.notesWrapper,
    linkWrapper: {
        css: css`
            display: flex;
        `,
    },
    link: linkGetActionLinkProps(ArrowiOSDownward, "right"),
    readOnlyNotesText: {
        wrapper: {
            css: spacingStyles(pxToRem(8), null),
        },
    },
    editNotesLink: productLineProps.editNotesLink,
    addNotesLink: productLineProps.addNotesLink,
};

const CartLineNotes: FC<Props> = ({
    cart,
    cartLine,
    editable = false,
    onNotesChange = () => {},
    label,
    extendedStyles,
}) => {
    const [isNotesFormModalOpen, setIsNotesFormModalOpen] = useState(false); // Starter Custom Code
    const [showLineNotes, setShowLineNotes] = useState(false);
    const lineNotesClickHandler = () => {
        setShowLineNotes(!showLineNotes);
    };
    /* Store Custom Code - Start */
    const {
        cartSettings: { showLineNotes: showLineNotesSetting },
    } = useSettingsCollection();
    /* Store Custom Code - End */

    const notesLinkRef = useRef<HTMLButtonElement>(null); // Starter Custom Code
    const [notes, setNotes] = useState(cartLine.notes);

    const changeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNotes(event.currentTarget.value);
    };

    const blurHandler = () => {
        onNotesChange(notes);
    };

    /* Starter Custom Code - Start */
    const openNotesFormModal = () => {
        setIsNotesFormModalOpen(true);
    };

    const closeNotesFormModal = () => {
        setIsNotesFormModalOpen(false);
    };

    const onLineNoteSave = (notes: string) => {
        onNotesChange(notes);
        closeNotesFormModal();
        notesLinkRef.current?.focus();
    };
    /* Starter Custom Code - End */

    const heading = cartLine.notes ? translate("Edit Notes") : translate("Add Notes"); // Starter Custom Code

    const [styles] = React.useState(() => mergeToNew(cartLineNotesStyles, extendedStyles));

    /* Store Custom Code - Start */
    if (showLineNotesSetting === false) {
        return null;
    }
    /* Store Custom Code - End */

    if (editable) {
        return (
            <>
                {/* Starter Custom Code - Start */}
                <StyledWrapper {...styles.wrapper}>
                    {cartLine.notes ? <SmallHeadingAndText heading={translate("Notes")} text={cartLine.notes} /> : null}
                    <Link
                        {...(cartLine.notes ? styles.editNotesLink : styles.addNotesLink)}
                        onClick={openNotesFormModal}
                        ref={notesLinkRef}
                    >
                        {heading}
                    </Link>
                </StyledWrapper>
                <EditNotesFormModal
                    notes={cartLine.notes}
                    testSelector="cartLine"
                    isDisabled={!cart.canModifyOrder}
                    modalIsOpen={isNotesFormModalOpen}
                    onCancel={closeNotesFormModal}
                    onSubmit={onLineNoteSave}
                />
                {/* Starter Custom Code - End */}
            </>
        );
    }

    if (!cartLine.notes) {
        return null;
    }

    return (
        <SmallHeadingAndText
            extendedStyles={styles.readOnlyNotesText /* Starter Custom Code */}
            heading={label || translate("Item Notes")}
            text={cartLine.notes}
        />
    );
};

export default withCartLine(CartLineNotes);
